/**
 * ClientAuthError API gövdesinde teknik alanlar (stage, errorCode) korunur;
 * panelde Türkçe gösterim için bu açıklamalar kullanılabilir.
 */

export const CLIENT_AUTH_STAGE_TR = {
  verifyCode: "Telefon girişi: SMS doğrulama kodunun doğrulanması",
  sendCode: "Telefon girişi: SMS doğrulama kodunun gönderilmesi",
  captcha: "Telefon girişi: güvenlik doğrulaması (reCAPTCHA)",
  signInWithGoogle: "Google ile oturum açma",
  signInWithEmailAndPassword: "E-posta ve şifre ile oturum açma (Firebase)",
  createUserWithEmailAndPassword: "E-posta ile yeni hesap oluşturma (Firebase)",
  getIdTokenAfterSignIn: "Oturum jetonunun (ID token) alınması",
  sendPasswordResetEmail: "Şifre sıfırlama e-postasının gönderilmesi",
  loginWithFirebase: "Sunucu: Firebase kimliği ile giriş",
  login: "Sunucu: e-posta ve şifre ile giriş",
  registerWithGoogle: "Sunucu: Google hesabı ile kayıt",
  loginOrRegister: "Sunucu: Google ile giriş veya kayıt",
};

export const CLIENT_AUTH_PROVIDER_TR = {
  FirebasePhone: "Telefon (SMS) doğrulaması — Firebase",
  EmailPassword: "E-posta ve şifre — Firebase",
  Google: "Google hesabı — Firebase",
  Backend: "Uygulama sunucusu (REST API)",
  Unknown: "Belirtilmedi",
};

/** Firebase Authentication sık görülen hata kodları (Türkçe kısa açıklama) */
export const CLIENT_AUTH_FIREBASE_ERROR_TR = {
  "auth/invalid-verification-code": "Girilen SMS doğrulama kodu hatalı veya geçersiz.",
  "auth/code-expired": "Doğrulama kodunun süresi doldu; yeni kod isteyin.",
  "auth/expired-action-code": "İşlem kodunun süresi doldu.",
  "auth/invalid-phone-number": "Telefon numarası geçersiz.",
  "auth/missing-phone-number": "Telefon numarası eksik.",
  "auth/too-many-requests": "Çok fazla deneme yapıldı; lütfen daha sonra tekrar deneyin.",
  "auth/quota-exceeded": "SMS kotası aşıldı; daha sonra tekrar deneyin.",
  "auth/network-request-failed": "Ağ bağlantısı hatası.",
  "auth/billing-not-enabled": "Telefon doğrulaması için proje faturalandırması kapalı olabilir.",
  "auth/user-not-found": "Bu bilgilerle kullanıcı bulunamadı.",
  "auth/wrong-password": "E-posta veya şifre hatalı.",
  "auth/invalid-email": "E-posta adresi geçersiz.",
  "auth/user-disabled": "Bu hesap devre dışı bırakılmış.",
  "auth/email-already-in-use": "Bu e-posta adresi zaten kullanılıyor.",
  "auth/weak-password": "Şifre çok zayıf.",
  "auth/invalid-credential": "Kimlik bilgileri geçersiz veya süresi dolmuş.",
  "auth/popup-closed-by-user": "Google oturum penceresi kullanıcı tarafından kapatıldı.",
  "auth/cancelled-popup-request": "Google oturum isteği iptal edildi.",
  "auth/popup-blocked": "Tarayıcı açılır pencereyi engelledi.",
  "auth/account-exists-with-different-credential": "Bu e-posta farklı bir giriş yöntemiyle kayıtlı.",
  "auth/operation-not-allowed": "Bu giriş yöntemi etkin değil.",
  "auth/internal-error": "Firebase sunucu hatası.",
};

export function getStageDescriptionTr(stage, override) {
  if (override) return override;
  if (!stage) return "";
  return CLIENT_AUTH_STAGE_TR[stage] || stage;
}

export function getProviderDescriptionTr(provider, override) {
  if (override) return override;
  if (!provider) return CLIENT_AUTH_PROVIDER_TR.Unknown;
  return CLIENT_AUTH_PROVIDER_TR[provider] || provider;
}

export function getFirebaseAuthErrorDescriptionTr(errorCode, override) {
  if (override) return override;
  if (!errorCode || typeof errorCode !== "string") return null;
  return CLIENT_AUTH_FIREBASE_ERROR_TR[errorCode] || null;
}
